export default {
  date: {
    basic: 'MM/DD/YYYY',
    full: 'DD/MM/YYYY - h:mm A Z'
  },
  time: {
    long: 'H:mm:ss A Z'
  }
}
